import type { TimeRangeValue } from '@elfsight/configurator-contracts';
import { differenceTimeIntervalInSeconds } from '@elfsight/widget-utils';
import { set } from 'date-fns';

export function timeRangeToDateRange(
  timeRange: TimeRangeValue,
  givenDate = new Date()
  // timeZone @TODO add TZ offset
) {
  const [from, until] = timeRange;
  const [fromHours, fromMinutes] = from.split(':').map(Number);

  const differenceInSeconds = differenceTimeIntervalInSeconds(from, until);

  const fromDate = set(givenDate, { hours: fromHours, minutes: fromMinutes });
  const untilDate = new Date(fromDate.getTime() + differenceInSeconds * 1000);

  return [fromDate, untilDate] as [Date, Date];
}
